<template>
  <div class="card shadow-none px-3 pt-3">
    <div class="row">
      <div class="col-sm-4 col-md-5">
        <div class="form-group mb15">
          <label class="label_uc">Name your schedule</label>
          <input type="text" placeholder="e.g. all employees" class="form-control" v-model='data.name'>
          <span v-show="publishErrorName" class="text-danger">
            {{ publishErrorName }}
          </span>
        </div>
      </div>
      <div class="col-sm-4 col-md-5">
        <div class="form-group mb15">
          <label class="label_uc">Select Recipients</label>
          <el-select 
            autofocus
            v-model="selectedRecipient"
            multiple
            filterable
            remote
            reserve-keyword
            class='hf_email_select hf_email_select_m'
            placeholder="Enter text to Search"
            :remote-method="remoteRecipientGroup"
            :loading="loading">
            <el-option :key="all" value="All Sheets" ></el-option>
            <el-option-group v-for="group in recipients" :key="group.label":label="group.label">
              <el-option
                v-for="item in group.options"
                :key="item.value"
                :label="item.label"
                :value="item.value+'|'+group.label">
              </el-option>
            </el-option-group>
          </el-select>
          <span v-show="publishError" class="text-danger">
            {{ publishError }}
          </span>
        </div>
      </div>
      <div class="col-sm-4 col-md-2">
        <div class="form-group mb15 mt16">
          <button v-if="action=='add'" @click='addBulkCampaign()' class="btn hf-btn-info btn-block btn-lg px-3">Start Scheduling</button>
          <button v-if="action=='edit'"  @click='addBulkCampaign()' class="btn hf-btn-info btn-block btn-lg px-3">{{published?'Published':'Publish Schedule'}}</button>
        </div>
      </div>
      <div class="col-sm-12 text-right" v-show="publish_check==1">
        <span class="text-danger">
          Please schedule atleast one campaign. 
        </span>
      </div>
    </div>
  </div>
</template>
<script>

export default {
    data() {
        return {
            data: {
                name: '',
                recipients_group: {
                    // 'departments': [],
                    // 'designations': [],
                    // 'locations': [],
                    // 'sheet': [],
                },
            },
            recipients: [],
            bulk_campaign_id: this.$route.params.id,
            publishError: '',
            publishErrorName: '',
            published:false,
            publish_check:0,
            recipientData:[],
            selectedRecipient:[],
            groupValueAllowed:0,
            allRecipients:[]

        }
    },
    props: ['action','auto_training_checks'],

    beforeMount() {

        this.$http.get('recipients/customfilters').then((response) => {

                //if (this.action == 'edit') {
                    this.$http.get('/bulk/campaign/' + this.bulk_campaign_id).then((responsedata) => {

                    let bulkCampaign = responsedata.data.data;
                    if(bulkCampaign.recipients){
                        this.data.name = bulkCampaign.name;
                        this.data.recipients_group = bulkCampaign.recipients;
                        if(bulkCampaign.status == 1) {
                            this.published = true;
                        }
                    } 
                    let keys = {};
                    let recipientData = [];                  
                    if(bulkCampaign.recipients){

                        recipientData = bulkCampaign.recipients;
                        
                        if(recipientData){
                            keys = Object.keys(recipientData);
                        }
                        this.recipientData = recipientData;
                        //console.log(this.recipientData);
                        //return 0;
                    }
                    for(let j= 0; j< keys.length; j++)
                    {      
                        let tempRecipient = recipientData[keys[j]];
                        let length = recipientData[keys[j]].length;

                        //get list name
                        if(keys[j] == 'sheet')
                        {   
                             for (var m = tempRecipient.length - 1; m >= 0; m--) 
                            {
                                if (tempRecipient[m] == 99999) 
                                {
                                    this.selectedRecipient.push("All Sheets");
                               }
                             }
                            /*if(tempRecipient.includes(99999)){
                                this.selectedRecipient.push("All Sheets");
                            }*/
                           // console.log(this.recipientData);
                           // console.log('11111111!!!!!!SSS');
                           // console.log(this.recipientData);
                            for(let k = 0; k < length; k++)
                            { 
                                let data = this.recipientData.sheet;
                                if(!data){
                                    data = this.recipientData.sheets;
                                }
                                //console.log(data);
                                if(data){
                                    for(var i = 0; i< data.length; i++)
                                    {
                                        if(data[i] == tempRecipient[k])
                                        {
                                            this.selectedRecipient.push(data[i]+'|'+keys[j]);
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                        else
                        {
                            for(let k = 0; k < length; k++)
                            {   
                                this.selectedRecipient.push(tempRecipient[k]+'|'+keys[j]);
                            } 
                        }
                    }

                    if(this.selectedRecipient.includes('All Sheets')){
                        this.selectedRecipient = [];
                        this.selectedRecipient.push('All Sheets');
                    }

                    this.recipientData = response.data;
                    // console.log('>>>>>>>>>>>>>>>>>>>>>>>>');
                    // console.log(response.data);
                    // console.log(this.recipientData);
                    let sheets =[];
                    var filterarray = Object.keys(this.recipientData.filters);
                    var totalGroups = filterarray.length;
                    totalGroups = totalGroups+1; // with all sheet
                    this.groupValueAllowed = Math.ceil(200/totalGroups);

                    this.recipientData.sheets.map((sheet)=>{
                        if(sheet.count>0 || sheet.updatecount>0){
                            sheets.push( {
                                label: sheet.name,
                                value: sheet.id
                            })
                       }
                    });

                    if(sheets.length==0)
                     {
                        $('.el-select-dropdown__item').css('display', 'none');
                     }else{
                        
                        var allsheets = sheets;
                        let allsheetObj = {
                        'label':'sheet',
                        'options': allsheets
                        }
                        this.allRecipients.push(allsheetObj);
                        var sheetslimit = sheets.slice(0,this.groupValueAllowed);
                     }

                    let sheetObj = {
                        'label':'sheet',
                        'options': sheetslimit
                    }


                    //console.log(this.allRecipients);
                    this.recipients.push(sheetObj);                   
                    
                    this.addPreselectedToFilter();
                    

                    for(let i = 0; i<filterarray.length; i++){                       
                        var filtername = filterarray[i];
                        let filtersObj = this.recipientData.filters[filtername].value.map((filter)=>{
                            return {
                                label: filter,
                                value: filter
                            }
                         });

                        var filtersObjlimited = filtersObj.slice(0,this.groupValueAllowed);
                        var selectedStatus = this.filterExists(this.recipients,filtername);
                        
                        var valuestoRemove = [];
                        if(selectedStatus!==false){
                            valuestoRemove = this.recipients[selectedStatus].options;
                          
                          filtersObjlimited = filtersObjlimited.concat(valuestoRemove);
                          filtersObjlimited = this.getUnique(filtersObjlimited,'label');                                                 
                        }

                        
                            let custumObjlimit = {
                                'label':this.recipientData.filters[filtername].filter_name,
                                'options': filtersObjlimited
                            }
                           var groupIndex = this.filterExists(this.recipients,custumObjlimit.label);
                            if(groupIndex!==false){
                                    this.recipients[groupIndex] = custumObjlimit;
                                }else{
                                    this.recipients.push(custumObjlimit);
                                }
                             this.recipients = this.getUnique(this.recipients,'label');
                        let custumObj = {
                            'label':this.recipientData.filters[filtername].filter_name,
                            'options': filtersObj
                        }
                        this.allRecipients.push(custumObj);
                        
                    }

               });
            
                })
                
            },
    mounted() {
         $("#addCampaignModal").on("hidden.bs.modal", this.clearErrorFlashContent)
    },
    methods: {

        getUnique(arr, comp) {

          const unique = arr
               .map(e => e[comp])

             // store the keys of the unique objects
            .map((e, i, final) => final.indexOf(e) === i && i)

            // eliminate the dead keys & store unique objects
            .filter(e => arr[e]).map(e => arr[e]);

           return unique;
        },

        filterExists(recipients,filtername){
            var status = false;
            for(var i=0; i<recipients.length;i++){
                if(recipients[i].label){
                    if(recipients[i].label==filtername){
                        return i;
                    }
               }
            }
            return status;
        },

        addPreselectedToFilter(){
            var blankObj = {};
            var allrecipients = [];
            for(let i=0;i<this.selectedRecipient.length;i++)
            {
                var locVar = this.selectedRecipient[i].split("|");
                var key = locVar[1];
                var value = locVar[0];
                //console.log(key+'####'+value);
                var option = [];
                var index = this.getArrayIndex(allrecipients,key);
                    if(index === false){
                        var filteredObj = {};
                        filteredObj.label = key;
                        var subfilterObj = {};
                        subfilterObj.label = value;
                        subfilterObj.value = value;
                        filteredObj.options = [];
                        filteredObj.options.push(subfilterObj);
                        allrecipients.push(filteredObj);

                    }else{

                        var subfilterObj = {};
                        subfilterObj.label = value;
                        subfilterObj.value = value;
                        if(allrecipients[index].options.length<this.groupValueAllowed){
                           allrecipients[index].options.push(subfilterObj); 
                        }
                    }
                    this.recipients = this.recipients.concat(allrecipients);

                    // this.mergesheet(this.recipients);

                    // console.log(this.recipients);
            }

        },

        remoteRecipientGroup(query){
            if (query !== '') {
              this.loading = true;
              var allrecipients = [];
              setTimeout(() => {
                this.loading = false;
                var recipients = this.allRecipients.filter(item => {
                    item.options.filter(subitem => {
                        if(subitem.label.toLowerCase()
                            .indexOf(query.toLowerCase()) > -1){
                               
                                var index = this.getArrayIndex(allrecipients,item.label);
                                if(index === false){
                                    var filteredObj = {};
                                    filteredObj.label = item.label;
                                    var subfilterObj = {};
                                    subfilterObj.label = subitem.label;
                                    subfilterObj.value = subitem.value;
                                    filteredObj.options = [];
                                    filteredObj.options.push(subfilterObj);
                                    allrecipients.push(filteredObj);

                                }else{

                                    var subfilterObj = {};
                                    subfilterObj.label = subitem.label;
                                    subfilterObj.value = subitem.value;
                                    if(allrecipients[index].options.length<this.groupValueAllowed){
                                       allrecipients[index].options.push(subfilterObj); 
                                    }
                                }
                            }
                    });
                });
                this.recipients = allrecipients;

              }, 100);
            } else {
            this.recipients = [];
            let sheets =[];
            this.allRecipients = [];
            var filterarray = Object.keys(this.recipientData.filters);
            var totalGroups = filterarray.length;
            totalGroups = totalGroups+1; // with all sheet
            this.groupValueAllowed = Math.ceil(100/totalGroups);

            this.recipientData.sheets.map((sheet)=>{
                if(sheet.count>0 || sheet.updatecount>0){
                    sheets.push( {
                        label: sheet.name,
                        value: sheet.id
                    })
               }
            });

            if(sheets.length==0)
             {
                $('.el-select-dropdown__item').css('display', 'none');
             }else{
                
                var allsheets = sheets;
                let allsheetObj = {
                'label':'sheet',
                'options': allsheets
                }
                this.allRecipients.push(allsheetObj);
               var sheetslimit = sheets.slice(0,this.groupValueAllowed);
             }

            let sheetObj = {
                'label':'sheet',
                'options': sheetslimit
            }



            this.recipients.push(sheetObj);                   
            
            this.addPreselectedToFilter();

            // if(this.selectedRecipient.indexOf('All Sheets')==-1){
            //      let sheetObj = {
            //         'label':'All Sheets',
            //         'options': [{
            //         'label':'All Sheets',
            //         'value': 'All Sheets'
            //     }]
            //     }
            //     this.recipients.push(sheetObj);
            // }

            for(let i = 0; i<filterarray.length; i++){                       
                var filtername = filterarray[i];
                let filtersObj = this.recipientData.filters[filtername].value.map((filter)=>{
                    return {
                        label: filter,
                        value: filter
                    }
                 });

                var filtersObjlimited = filtersObj.slice(0,this.groupValueAllowed);

                var selectedStatus = this.filterExists(this.recipients,filtername);

                var valuestoRemove = [];
                if(selectedStatus!==false){
                    valuestoRemove = this.recipients[selectedStatus].options;



                 filtersObjlimited = filtersObjlimited.concat(valuestoRemove);                           
                }

                filtersObjlimited = this.getUnique(filtersObjlimited,'label');
                
                    let custumObjlimit = {
                        'label':this.recipientData.filters[filtername].filter_name,
                        'options': filtersObjlimited
                    }
                     var groupIndex = this.filterExists(this.recipients,custumObjlimit.label);
                        if(groupIndex!==false){
                            this.recipients[groupIndex] = custumObjlimit;
                        }else{
                            this.recipients.push(custumObjlimit);
                        }
                    this.recipients = this.getUnique(this.recipients,'label');
                let custumObj = {
                    'label':this.recipientData.filters[filtername].filter_name,
                    'options': filtersObj
                }
                this.allRecipients.push(custumObj);
            }
            }

        },

        getArrayIndex(allrecipients,label){
            var status = false;
            for(var i=0; i<allrecipients.length;i++){
                if(allrecipients[i].label== label){
                    return i;
                }
            }
            return status;
        },

        getData(){
            if (this.action == 'edit') {
                this.$http.get('/bulk/campaign/' + this.bulk_campaign_id).then((response) => {
                    let bulkCampaign = response.data.data;
                    this.data.name = bulkCampaign.name;
                    this.data.recipients_group = bulkCampaign.recipients;
                    if(bulkCampaign.status == 1) {
                        this.published = true;
                    }

                    let recipientData = bulkCampaign.recipients;
                    let keys = {};
                    if(recipientData){
                        keys = Object.keys(recipientData);
                    }
                    for(let j= 0; j< keys.length; j++)
                    {      
                        let tempRecipient = recipientData[keys[j]];
                        let length = recipientData[keys[j]].length;

                        //get list name
                        if(keys[j] == 'sheet')
                        {   
                            for (var i = tempRecipient.length - 1; i >= 0; i--) 
                            {
                                if (tempRecipient[i] == 99999) 
                                {
                                    this.selectedRecipient.push("All Sheets");
                                }
                            }
                            /*if(tempRecipient.includes(99999)){
                                this.selectedRecipient.push("All Sheets");
                            }*/
                            for(let k = 0; k < length; k++)
                            { 
                                let data = this.recipientData.sheets;
                                for(var i = 0; i< data.length; i++)
                                {
                                    if(data[i].id == tempRecipient[k])
                                    {
                                        this.selectedRecipient.push(data[i].id+'|'+keys[j]);
                                        break;
                                    }
                                }
                            }
                        }
                        else
                        {
                            for(let k = 0; k < length; k++)
                            {   
                                this.selectedRecipient.push(tempRecipient[k]+'|'+keys[j]);
                            } 
                        }
                    }
               });
            }
        },
        addBulkCampaign() {

            if (this.data.name.match("^[+=@-].*")) {
                this.publishError = 'Name of your schedule is not valid';
                return false;
            }
            let allflag = 0;
                    
                for( let l = 0; l < this.selectedRecipient.length; l++){
                    if( this.selectedRecipient[l] == "All Sheets" ){
                        allflag = 1;break;
                    }
                }
                if( allflag == 0 ){

                    var blankObj = {};
                    
                    for(let i=0;i<this.selectedRecipient.length;i++)
                    {
                        var locVar = this.selectedRecipient[i].split("|");
                        var key = locVar[1];
                        if(blankObj[key])
                        {
                            blankObj[key].push(locVar[0]);
                        }else
                        {
                            var array = [];
                            array.push(locVar[0]);
                            blankObj[key] = array;
                        }
                    }
                    this.data.recipients_group = blankObj;                        
                }else{
                    this.data.recipients_group = {};
                    this.data.recipients_group.sheet =[];
                    this.data.recipients_group.sheet.push(99999);
                }
                
                if(this.selectedRecipient == '' || this.selectedRecipient.length==0)
                {
                    this.isRecipientSelected = true;
                    this.publishError = 'Please select recipients.';
                    return;
                }

            let postData =
                {
                    name: this.data.name,
                    recipients: this.data.recipients_group
                }

            this.publishErrorName = "";
            if (this.data.name == "") {
                this.publishErrorName = 'Please enter bulk campaign name';
                return;
            }
            if (this.action == 'add') {

                this.$http.post('bulk/campaign', postData).then((response) => {
                    this.$router.push({ path: '/bulk/campains/schedule/' + response.data.data.id })
                    let options = {
                        'message':"Your campaigns have been scheduled successfully.",
                        'timeout':5000,
                        'position': 'top',
                        'style': 'bar',
                        'type':'success'
                    }
                    $('body').pgNotification(options).show();  
                    $('#addCampaignModal').modal('hide');

                })
            }
            else {
                this.publish_check=0;

                
                if (this.data.name.match("^[+=@-].*")) {
                    this.publishError = 'Name of your schedule is not valid';
                    return false;
                }
                if(this.$parent.campaigns.length==0)
                {
                   this.publish_check=1;
                   return false;
                }
                this.publishError = '';
                let publishData =
                    {
                        id: this.bulk_campaign_id,
                        auto_training_data: this.auto_training_checks,
                        name:this.data.name,
                        recipients: this.data.recipients_group
                    }
                this.$http.post('/bulk/campaign/publish', publishData).then((response) => {
                    if (response.data) {
                        this.publishError = response.data;
                    } else{
                        this.published = true;

                        let options = {
                            'message':"Your campaigns have been scheduled successfully.",
                            'timeout':5000,
                             'position': 'top',
                             'style': 'bar',
                            'type':'success'
                        }
                        $('body').pgNotification(options).show();   
                         this.$router.push({ path: '/campaigns'})
                    }
                })

            }

        },
        clearErrorFlashContent(){
            this.publishError = false;
        }

    }
}
</script>



// WEBPACK FOOTER //
// bulkCampaignCard.vue?17c46e3c